import {
  changedAttempts,
  type AttemptChanges,
} from "@libs/buy-on-behalf-client/purchase";
import type { RealtimeCacheInvalidationCommand } from "./types";

type Listener = (attemptId: string | null) => void;

const listeners = new Set<Listener>();

/**
 * The app's realtime socket as a purchase hears it: each watched attempt is
 * told when a `buyOnBehalf.attempt` hint names it, or names none (the
 * socket's connect resync). The purchase client reads the attempt again at
 * once, and still polls as the fallback while the socket is closed
 * (backgrounded, offline, reconnecting).
 */
export const realtimeAttemptChanges: AttemptChanges = (onChange) => {
  listeners.add(onChange);
  return () => {
    listeners.delete(onChange);
  };
};

/** Tells every watched attempt what a socket message says changed. */
export function tellAttemptChanges(
  commands: readonly RealtimeCacheInvalidationCommand[],
) {
  for (const attemptId of changedAttempts(commands)) {
    for (const listener of [...listeners]) listener(attemptId);
  }
}
